import type { ComponentType } from "react";
import GuiaCompletaNom035 from "./guia-completa-nom-035";
import Nom035VsNom030 from "./nom-035-vs-nom-030";
import MejoresPlataformasNom035 from "./mejores-plataformas-nom-035";

export const BLOG_POST_COMPONENTS: Record<string, ComponentType> = {
  "guia-completa-nom-035-empresas-mexico": GuiaCompletaNom035,
  "nom-035-vs-nom-030-diferencias": Nom035VsNom030,
  "mejores-plataformas-software-nom-035-mexico": MejoresPlataformasNom035,
};
